import { IonRouterOutlet, IonSplitPane } from '@ionic/react';
import { Route } from 'react-router-dom';
// Pages
import Login from './Login/Login';
import Dashboard from './Dashboard/Dashboard';
import LandingPage from './LandingPage/LandingPage';
import LightsControl from './LightsControl/LightsControl';
import Light from './Light/Light';
import DeviceLight from './DeviceLight/DeviceLight';
import DeviceRequest from './DeviceRequest/DeviceRequest';
import Camera from './Camera/Camera';
// Components
// import Menu from '../components/Menu';

function Layout() {
    return (
        <IonSplitPane contentId="main">
            {/* <Menu /> */}
            <IonRouterOutlet id="main">
                <Route path="/login" exact={true} component={Login} />
                <Route path="/dashboard" exact={true} component={Dashboard} />
                <Route path="/lights-control" exact={true} component={LightsControl} />                
                <Route path="/light" exact={true} component={Light} />                
                {/* <Route path="/devicelight" exact={true} component={DeviceLight} />                 */}
                <Route path="/devicelight/:area_id" component={DeviceLight} />
                <Route path="/eachdevicelight/:cam_id" component={DeviceRequest} />
                <Route path="/camera" exact={true} component={Camera} />                
                <Route path="/" exact={true} component={LandingPage} />
            </IonRouterOutlet>
        </IonSplitPane>
    )
}

export default Layout